import { supabase } from "@/integrations/supabase/client";
import { resolveVisitorGeo, getCachedVisitorGeo } from "@/lib/visitor-geo";

function getGuestSessionId(): string {
  try {
    let sid = localStorage.getItem("padelcorner-session-id");
    if (!sid) {
      sid = `guest_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("padelcorner-session-id", sid);
    }
    return sid;
  } catch {
    return `guest_${Date.now()}`;
  }
}

// Throttle duplicate logs (same product + action) within window
const recent = new Map<string, number>();
const THROTTLE_MS = 30_000;

export type ProductActivityAction = "view" | "click";

export async function logProductActivity(params: {
  action: ProductActivityAction;
  productId?: string | null;
  productName?: string | null;
  productSlug?: string | null;
  productSku?: string | null;
  source?: string | null;
}) {
  try {
    const key = `${params.action}:${params.productId ?? params.productSlug ?? ""}`;
    const now = Date.now();
    const last = recent.get(key) ?? 0;
    if (now - last < THROTTLE_MS) return;
    recent.set(key, now);

    const { data: { user } } = await supabase.auth.getUser();
    const geo = getCachedVisitorGeo() ?? (await resolveVisitorGeo());
    await supabase.from("product_activity_log").insert({
      action: params.action,
      product_id: params.productId ?? null,
      product_name: params.productName ?? null,
      product_slug: params.productSlug ?? null,
      product_sku: params.productSku ?? null,
      source: params.source ?? null,
      session_id: getGuestSessionId(),
      user_id: user?.id ?? null,
      user_email: user?.email ?? null,
      page_url: typeof window !== "undefined" ? window.location.href : null,
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      country: geo.country,
      country_code: geo.country_code,
    });
  } catch (err) {
    console.warn("[product-activity] failed", err);
  }
}
